module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"list":"List","scatter":"Scatter plot","cvContributionPage":"CV contribution page"},"ja":{"list":"リスト","scatter":"散布図","cvContributionPage":"CV貢献ページ"},"zh-hant":{"list":"清單","scatter":"散布圖","cvContributionPage":"CV貢獻頁面"},"zh-hans":{"list":"清单","scatter":"散布图","cvContributionPage":"CV贡献页面"}}')
  delete Component.options._Ctor
}
